module.exports = __webpack_public_path__ + "static/img-cf803d67fe99b9da3eab76686d1235ca.jpeg";